import clsx from 'clsx';
import { Tab } from '../Tab';

export interface SegmentedControlItem {
  label: string;
  id: string;
}

export interface SegmentedControlProps {
  items: SegmentedControlItem[];
  selectedIds: string[];
  onChange: (ids: string[]) => void;
  multiple?: boolean;
  className?: string;
}

export const SegmentedControl = ({
  items,
  selectedIds,
  onChange,
  multiple = false,
  className,
}: SegmentedControlProps) => {
  const handleClick = (id: string) => {
    if (!multiple) {
      onChange([id]);
      return;
    }
    if (selectedIds.includes(id)) {
      const next = selectedIds.filter(s => s !== id);
      onChange(next.length === 0 ? [id] : next);
    } else {
      onChange([...selectedIds, id]);
    }
  };

  return (
    <div className={clsx('flex gap-2', className)}>
      {items.map(item => (
        <Tab
          key={item.id}
          selected={selectedIds.includes(item.id)}
          onClick={() => handleClick(item.id)}
          variant="filled"
          appearance="pill"
          className="flex-[1_0_0] h-12 justify-center bg-white gap-2 border-2 border-[--tab-border-default]"
        >
          {item.label}
        </Tab>
      ))}
    </div>
  );
};
